import React, { Component } from 'react';
import styles from './style.css';
import Util from '../utilPc/';
import jsonp from '../base/jsonp';
import hasSafeKeyword from '../base/hasSafeKeyword';
import { formatImage } from '../../../../base/publicMethod/index';

const pcVideoUtil = new Util();

class Recommend extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isRender: true,
            showItem: false,
            leftable: true,
            rightable: true,
            containerLeftHover: false,
            containerRightHover: false,
            recommend: [],
        };
    }
    async componentDidMount() {
        await this.getData();
    }
    getData = async () => {
        const { vid, title, base62Id, keywords = '' } = this.props.videoInfo;
        const safeKeywords = [
            '习近平',
            '李克强',
            '栗战书',
            '汪洋',
            '王沪宁',
            '赵乐际',
            '韩正',
            '彭丽媛',
            '胡锦涛',
            '江泽民',
            '新时代',
        ];
        const safeHost = ['news.ifeng.com', 'inews.ifeng.com'];
        const currentHost = window.location.hostname;
        // 该参数会影响算法的策略，如果引用组件的页面的host是safeHost 或者传入视频组件的keywords中间包含 safeKeywords中的一个的时候，需要设置from为pc_safe，即使用安全策略，否则就使用对应分类策略，
        const from =
            safeHost.includes(currentHost) ||
            safeKeywords.reduce((result, keyword) => {
                if (result) {
                    return result;
                } else {
                    return keywords.includes(keyword);
                }
            }, false)
                ? 'pc_safe'
                : 'vcis_pc';

        try {
            let num = 0;
            let callbackName = `callbackRecommend_${num}`;

            while (window[callbackName]) {
                num++;
                callbackName = `callbackRecommend_${num}`;
            }

            // 如果能获取到视频的base62Id，传给服务端可以减少 vid-> base62Id 的查询。
            const result = await jsonp(
                `https://shankapi.ifeng.com/feedflow/videoRecom/getRecomlist_v2/${
                    base62Id || vid
                }/${from}/${callbackName}`,
                // `//tv.ifeng.com/common/video-player-final-recommendation_${callbackName}/getByKey.json`,
                {
                    jsonpCallback: callbackName,
                    data: {
                        title,
                    },
                    cache: false,
                },
            );

            // base62Id: "84Sz4vakxzQ"
            // pcUrl: "https://v.ifeng.com/c/84Sz4vakxzQ"
            // posterUrl: "https://x0.ifengimg.com/res/2021/527049501D93D5515EB8E403C19E395F40E0DF52_size536_w1280_h720.jpeg"
            // title: "中国在各领域奋起直追！拜登或将召集首次“四国峰会”对抗中国"
            if (result.code === 0) {
                this.setState({
                    recommend: result.data,
                });
            }
        } catch (e) {
            console.error('recommend接口报错', e);
        }
    };

    clearPicUrl = (url) => {
        if (!url) {
            return url;
        }

        if (url.indexOf('http://') === 0) {
            url = url.replace('http://', '//');
        } else if (url.indexOf('https://') === 0) {
            url = url.replace('https://', '//');
        }

        if (url.indexOf('http://') > 0) {
            url = url.replace('http://', '');
        } else if (url.indexOf('https://') > 0) {
            url = url.replace('https://', '');
        }

        return url;
    };

    /**
     * 初始化component
     */
    getChidren() {
        const data = this.state.recommend;

        const children = data.map((item) => (
            <li key={item.base62Id}>
                <div>
                    <a href={item.pcUrl}>
                        <img src={formatImage(this.clearPicUrl(item.posterUrl), 160, 90)} />
                        <i />
                        {/* <span className="time">{pcVideoUtil.formatTime(item.duration)}</span> */}
                        <em>{item.title}</em>
                    </a>
                </div>
            </li>
        ));

        return <ul id="js_recommend_list">{children}</ul>;
    }
    turnLeft = () => {
        this.turn('left');
    };
    turnRight = () => {
        this.turn('right');
    };
    turn = (type) => {
        // const containerRight = document.getElementsByClassName('containerRight')[0];
        // const containerLeft = document.getElementsByClassName('containerLeft')[0];

        /**
         * 后推荐宽度
         */
        const recommendWidth = parseInt(pcVideoUtil.getStyle(document.getElementById('js_recommend_container')).width);
        const recommendMax = 180 * pcVideoUtil.delNodes(document.getElementById('js_recommend_list')).childNodes.length;

        const change = type === 'right' ? -1 : 1;
        const recommendList = document.getElementById('js_recommend_list');
        const _curLeft = parseInt(pcVideoUtil.getStyle(recommendList).left);
        let changeLeft = _curLeft + change * recommendWidth;

        if (type === 'left') {
            if (_curLeft === 0) {
                return;
            }
            changeLeft = Math.min(changeLeft, 0);
        } else if (type === 'right') {
            changeLeft = Math.max(changeLeft, -(recommendMax - recommendWidth));
        }

        recommendList.style.left = `${changeLeft}px`;

        this.setState({
            containerLeftHover: true,
            containerRightHover: true,
        });

        if (changeLeft === 0) {
            this.setState({
                containerLeftHover: false,
            });
        } else if (changeLeft === -(recommendMax - recommendWidth)) {
            this.setState({
                containerRightHover: false,
            });
        }
    };
    show = () => {
        this.setState({
            showItem: true,
        });
    };
    hide = () => {
        this.setState({
            showItem: false,
        });
    };
    destroy = () => {
        this.setState({
            isRender: false,
        });
    };
    render() {
        const children = this.getChidren();
        const { keywords = '' } = this.props.videoInfo;
        const { showItem, leftable, rightable, containerLeftHover, containerRightHover, isRender } = this.state;

        return isRender ? (
            <div
                id="js_video_recommend"
                className={styles.videorecommend}
                style={{ display: showItem ? 'block' : 'none' }}>
                {!hasSafeKeyword(keywords) ? (
                    <div className={styles.videoRecommendLayout}>
                        <div className={styles.videoRecommendPosition}>
                            <div className={containerLeftHover ? styles.containerLeftHover : styles.containerLeft}>
                                <div
                                    className={leftable ? styles.recommendLeft : styles.recommendLeftDisabled}
                                    onClick={this.turnLeft}
                                    id="js_recommend_pageL"
                                />
                            </div>
                            <div className={containerRightHover ? styles.containerRightHover : styles.containerRight}>
                                <div
                                    className={rightable ? styles.recommendRight : styles.recommendRightDisabled}
                                    onClick={this.turnRight}
                                    id="js_recommend_pageR"
                                />
                            </div>
                            <div className={styles.containerList} id="js_recommend_container">
                                {children}
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        ) : null;
    }
}

export default Recommend;
